import React from 'react';
import AdminsEditor from '../containers/AdminsEditor.jsx';

export default (props) => (
  <AdminsEditor {...props} />
);
